import React from 'react'
import PropTypes from 'prop-types'

import classes from './TermsAndConditionsHeader.module.scss'

const TermsAndConditionsHeader = ({ logoUrl }) => (
  <header className={classes.header}>
    <div className={`${classes.logoWrap} header-control-surface`}>
      <img src={logoUrl} className={classes.logo} alt="" />
    </div>
  </header>
)

TermsAndConditionsHeader.displayName = 'TermsAndConditionsHeader'
TermsAndConditionsHeader.propTypes = {
  logoUrl: PropTypes.string,
}
TermsAndConditionsHeader.defaultProps = {
  logoUrl: '',
}

export default TermsAndConditionsHeader
